import React from "react";
import { Navbar, Container, Dropdown } from "react-bootstrap";
import { useTheme } from "../contexts/ThemeContext";
import "../styles/Header.css";
import { useLocation, Link, useNavigate } from "react-router-dom";

const Header = () => {
  const { theme } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const isAnalyticsPage = location.pathname === "/dataAnalytics";
  const username = localStorage.getItem("user_name") || "Admin";

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <Navbar
      bg={theme.isDarkMode ? "dark" : "light"}
      variant={theme.isDarkMode ? "dark" : "light"}
      className="header mb-4"
    >
      <Container fluid>
        <Navbar.Brand href="#">
          <i className="fas fa-chart-line me-2"></i>
          {isAnalyticsPage ? "Data Analytics" : "Dashboard Analytics"}
        </Navbar.Brand>

        <div className="d-flex align-items-center">
          <Link
            className="me-3 nav-link-custom"
            style={{
              color: theme.isDarkMode ? "#c9d1d9" : "black",
              textDecoration: "none",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "0.9rem",
              transition: "all 0.2s",
            }}
            to={isAnalyticsPage ? "/healthdashboard" : "/dataAnalytics"}
          >
            {isAnalyticsPage
              ? "Health Analytics"
              : "Data Analytics"}
          </Link>
          <Link
            className="me-3 nav-link-custom"
            style={{
              color: theme.isDarkMode ? "#c9d1d9" : "black",
              textDecoration: "none",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "0.9rem",
              transition: "all 0.2s",
            }}
            to="/rag-management"
          >
            <i className="fas fa-database me-1"></i>
            RAG Management
          </Link>
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="transparent"
              id="dropdown-user"
              style={{
                color: theme.isDarkMode ? "#c9d1d9" : "black",
                border: "none",
                boxShadow: "none",
              }}
            >
              <i className="fas fa-user-circle me-1"></i> <span style={{ fontFamily: "'JetBrains Mono', monospace" }}>{username}</span>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Container>
    </Navbar>
  );
};

export default Header;
